import { Icon, IconProps } from "../";

export const PersonRemoveIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M54,1056 C54,1053.79 52.21,1052 50,1052 C47.79,1052 46,1053.79 46,1056 C46,1058.21 47.79,1060 50,1060 C52.21,1060 54,1058.21 54,1056 Z M42,1066 L42,1067 C42,1067.55 42.45,1068 43,1068 L57,1068 C57.55,1068 58,1067.55 58,1067 L58,1066 C58,1063.34 52.67,1062 50,1062 C47.33,1062 42,1063.34 42,1066 Z M58,1058 L62,1058 C62.55,1058 63,1058.45 63,1059 L63,1059 C63,1059.55 62.55,1060 62,1060 L58,1060 C57.45,1060 57,1059.55 57,1059 L57,1059 C57,1058.45 57.45,1058 58,1058 Z"
        transform="translate(-40 -1048)"
      />
    </Icon>
  );
};
